/* eslint-disable react-hooks/exhaustive-deps */
import {
  Row,
  Col,
  Modal,
  Form,
  Input,
  Spin,
  Select,
  DatePicker,
  Button,
  InputNumber,
  message,
  Tooltip,
  Space,
  Tabs,
  Table,
} from 'antd';
import CustomSelect from '../customSelect';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { EditOutlined } from '@ant-design/icons';
import TabPane from 'antd/es/tabs/TabPane';
import { use } from 'react';

const { Option } = Select;
const { TextArea } = Input;

const QuotationModal = props => {
  const dispatch = useDispatch();
  const { qid } = useParams();
  const [form] = Form.useForm();
  const { open, close, questionId, type, questionData, openPayment, setWarningModalVisible } =
    props;
  const { isQuestionLoading, isCommonUpdateLoading, commonMsg } = useSelector(
    state => state.common,
  );
  const { isBillLoading, billPlanList } = useSelector(state => state.expert);
  useEffect(() => {
    dispatch({ type: 'BILL_PLAN_REQUEST' });
  }, [questionId]);

  useEffect(() => {
    if (
      questionData.quotation_detail !== undefined &&
      questionData.quotation_detail !== null &&
      !isBillLoading &&
      billPlanList.length > 0
    ) {
      if (Object.keys(questionData.quotation_detail).length > 0) {
        form.setFieldsValue({
          title: questionData.quotation_detail?.assignment_title,
          disc: questionData.quotation_detail?.details,
          price: questionData.quotation_detail?.price,
          billing_plan_id: parseInt(questionData.quotation_detail?.billing_plan_id),
          cpa: questionData.quotation_detail?.Current_payable_amount,
          percent_fee_due: questionData.quotation_detail?.percentage_of_fee_due,
          // billing_plan_id: 2,
          delivery_date:
            questionData.quotation_detail.delivery_date !== null
              ? moment(questionData.quotation_detail?.delivery_date)
              : '',
        });
      }
    }
  }, [questionData, isBillLoading, billPlanList]);

  useEffect(() => {
    if (!isCommonUpdateLoading && commonMsg === 'success') {
      dispatch({ type: 'CLEAR_COMMON' });
      close(false);
    }
  }, [isCommonUpdateLoading, commonMsg]);

  const onFinish = values => {
    if (type === 'customer') {
      form
        .validateFields()
        .then(values => {
          openPayment(true);
          // // values.delivery_date = moment(values.delivery_date).format("YYYY-MM-DD");
          // let tmpFormData = {
          //     accepted: 1,
          //     question_id: qid
          // };

          // dispatch({
          //     type: 'COMMON_PUT_POST_REQUEST',
          //     reqType: "put",
          //     module: "accept-quotation",
          //     formData: tmpFormData
          // });
        })
        .catch(errorInfo => { });
    } else if (type === 'expert') {
    
      form
        .validateFields()
        .then(values => {
          values.delivery_date = moment(new Date(values.delivery_date)).format('YYYY-MM-DD');
          // values.delivery_date = moment(values.delivery_date).format("YYYY-MM-DD");
          values.price = parseInt(values.price);
          values['percentage_of_fee_due'] = values.percent_fee_due;
          values['Current_payable_amount'] = values.cpa;
          dispatch({
            type: 'COMMON_PUT_POST_REQUEST',
            reqType: 'post',
            module: 'reply-quotation',
            formData: values,
          });
        })
        .catch(errorInfo => {
          console.log(errorInfo);
        });
    }
  };
  const { paymentTax } = useSelector(state => state.expert);

  const onCancel = () => {
    let tmpObj = {
      quotation_id: questionData?.quotation_detail?.id,
      action: 'rejected',
    };
    // message.error('Please send message to expert in order to revise the quotation');
    // close(false);
    dispatch({ type: 'PAYMENT_TAX_REQUEST', formData: tmpObj });
  };
  useEffect(() => {
    if(paymentTax?.message){
      message.info(paymentTax?.message);
      close(false);
    }
  },[paymentTax]) 
  const optionsList = tmpLocation => {
    let locationOptions = [];
    if (tmpLocation.length > 0) {
      tmpLocation.map(item => {
        locationOptions.push({
          value: item.id,
          label: item.name,
        });
      });
    }
    return locationOptions;
  };

  const selectAfter = (
    <CustomSelect
      placeholder="Select an option"
      size="large"
      defaultValue="CAD"
      style={{ width: 80 }}
    >
      <Option value="CAD">CAD</Option>
    </CustomSelect>
  );
  function setPrice(type) {
    let percent = form.getFieldValue().percent_fee_due;
    let price = form.getFieldValue().price;
    let cpa = form.getFieldValue().cpa;
    if (typeof price !== 'number' || isNaN(price)) return;
    if (type == 'price' && (typeof cpa !== 'number' || isNaN(cpa))) return;
    if (type == 'percent') {
      form.setFieldsValue({
        cpa: Math.floor((percent / 100) * price),
      });
    } else if (type == 'cpa') {
      form.setFieldsValue({
        percent_fee_due: Math.floor((cpa / price) * 100),
      });
    } else if (type == 'price') {
      form.setFieldsValue({
        cpa: Math.floor((percent / 100) * price),
      });
    }
  }
  const [disabledAgreedTotalFee, setDisabledAgreedTotalFee] = useState(false);
  const [disabledPercent, setDisabledPercent] = useState(false);
  const [disabledCpa, setDisabledCpa] = useState(false);
  return (
    <Modal
      title={'Quotation Details'}
      className="payment-modal quotation-modal"
      open={open}
      // onOk={onFinish}
      // header={false}
      footer={false}
      onCancel={() => close(false)}
      okText={'Accept & send quotation'}
      okButtonProps={{
        disabled: false,
        loading: false,
      }}
      width={800}
    >
      {isQuestionLoading ? (
        <Spin />
      ) : (
        <>
          <Tabs>
            <TabPane tab="Quotation" key="1">
              <Form
                layout="vertical"
                name="basic"
                form={form}
                onFinish={onFinish}
                autoComplete="off"
                className='quoatation-modal-form-field'
              >
                <Row gutter={30}>
                  <Col xs={24} sm={12} md={24} lg={24} xl={24}>
                    <Form.Item
                      style={{ display: 'none' }}
                      name={'question_id'}
                      initialValue={questionId}
                    >
                      <Input defaultValue={questionId} />
                    </Form.Item>
                    <Form.Item
                      label="Assignment Title"
                      name="title"
                      rules={[
                        {
                          required: true,
                          message: 'Please assigment title',
                        },
                        {
                          max: '100',
                          message: 'Maximum 100 characters are allowed',
                        },
                      ]}
                    >
                      <Input
                        size="large"
                        disabled={type !== 'expert' ? true : false}
                        placeholder="Assigment title"
                      />
                    </Form.Item>
                  </Col>

                  <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                    <Form.Item
                      label="Details of the assignment"
                      name="disc"
                      rules={[
                        {
                          required: true,
                          message: 'Please enter details',
                        },
                        {
                          max: 5000,
                          message: 'Maximum 5000 characters are allowed',
                        },
                      ]}
                    >
                      <TextArea
                        rows={5}
                        disabled={type !== 'expert' ? true : false}
                        placeholder="Assignment details"
                        onInput={e => {
                          const el = e.target;
                          el.style.height = 'auto'; // Always reset first
                          if (el.value.trim() === '') {
                            el.style.height = 'auto'; // Reset to default if empty
                          } else {
                            el.style.maxHeight = '40vh';
                            el.style.height = el.scrollHeight + 'px';
                          }
                        }}
                      />
                    </Form.Item>
                  </Col>
                  <Col
                    xs={24}
                    sm={24}
                    md={12}
                    lg={12}
                    xl={12}
                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                  >
                    {type !== 'expert' && (
                      <Form.Item label={'Price'} name="price">
                        <Input
                          size="large"
                          disabled={qid ? true : false}
                          placeholder={'$CA'}
                          autoComplete="new-state"
                          addonAfter={'$CA'}
                        />
                      </Form.Item>
                    )}
                    {type === 'expert' && (
                      <>
                        <Form.Item
                          label={'Agreed total fee'}
                          name="price"
                          rules={[
                            { required: true, message: 'Please enter price' },
                            {
                              pattern: new RegExp(/^[0-9]{1,10}$/),
                              message: 'Please enter valid price',
                            },
                          ]}
                        >
                          {/* <Input.Group style={{ display: 'flex' }} compact> */}
                          <InputNumber
                            addonAfter={'$CAD'}
                            style={{ width: '100%' }}
                            size="large"
                            readOnly={type !== 'expert' ? true : disabledAgreedTotalFee}
                            placeholder={'$CAD'}
                            autoComplete="new-state"
                            onChange={() => {
                              setPrice('price');
                            }}
                            name="price"
                          />

                          {/* </Input.Group> */}
                        </Form.Item>
                        <div
                          style={{
                            fontSize: 16,
                            // color: '#1890ff',
                            width: '10%',
                            // backgroundColor: 'gray',
                            height: '2.5rem',
                            cursor: 'pointer',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                          onClick={() => {
                            setDisabledAgreedTotalFee(!disabledAgreedTotalFee);
                          }}
                        >
                          <EditOutlined style={{ color: 'black' }} />
                        </div>
                      </>
                    )}
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <Form.Item
                      label="Billing plan"
                      name="billing_plan_id"
                      rules={[{ required: true, message: 'Please select location' }]}
                    >
                      <CustomSelect
                        placeholder="Select an option"
                        style={{
                          width: '100%',
                        }}
                        size="large"
                        showSearch
                        loading={isBillLoading}
                        allowClear
                        filterOption={(input, option) =>
                          (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                        }
                        disabled={type !== 'expert' ? true : false}
                        options={optionsList(billPlanList)}
                      />
                    </Form.Item>
                  </Col>

                  <Col
                    xs={24}
                    sm={24}
                    md={12}
                    lg={12}
                    xl={12}
                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                  >
                    {/* {
                      disabledPercent &&  <div  style = {{width: '70%',backgroundColor: 'rgba(0, 0, 0, 0.1)',borderRadius: '10px',height: '45%',position: "absolute",zIndex: 100,left: "5%"}}>
                      
                      </div>
                    } */}
                   
                    <Form.Item  label="Percentage of fee due" name={'percent_fee_due'}>
                      {/* <Input.Group style={{ display: 'flex' }} compact> */}
                      <InputNumber
                        addonAfter={'%'}
                        style={{
                          width: '100%',
                         
                        }}
                        size="large"
                        readOnly={type !== 'expert' ? true : disabledPercent}
                        placeholder={'Percentage of fee due'}
                        autoComplete="new-state"
                        onChange={() => {
                          setPrice('percent');
                        }}
                        name={'percent_fee_due'}
                        
                      />

                      {/* </Input.Group> */}
                    </Form.Item>
                    <div
                      style={{
                        fontSize: 16,
                        // color: '#1890ff',
                        width: '10%',
                        // backgroundColor: 'gray',
                        height: '2.5rem',
                        cursor: 'pointer',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                      onClick={() => {
                        setDisabledPercent(!disabledPercent);
                      }}
                    >
                      <EditOutlined style={{ color: 'black' }} />
                    </div>
                  </Col>
                  <Col
                    xs={24}
                    sm={24}
                    md={12}
                    lg={12}
                    xl={12}
                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                  >
                    <Form.Item
                      // rules={[{ required: true, message: 'Please enter valid price', max: 100, min: 0 }]}
                      label="Current payable amount"
                      name={'cpa'}
                    >
                      {/* <Input.Group style={{ display: 'flex' }} compact> */}
                      <InputNumber
                        addonAfter={'$CA'}
                        style={{ width: '100%' }}
                        size="large"
                        readOnly={type !== 'expert' ? true : disabledCpa}
                        placeholder={'Current payable amount'}
                        autoComplete="new-state"
                        onChange={() => {
                          setPrice('cpa');
                        }}
                      />

                      {/* </Input.Group> */}
                    </Form.Item>
                    <div
                      style={{
                        fontSize: 16,

                        width: '10%',
                        // backgroundColor: 'gray',
                        height: '2.5rem',

                        cursor: 'pointer',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                      onClick={() => {
                        setDisabledCpa(!disabledCpa);
                      }}
                    >
                      <EditOutlined style={{ color: 'black' }} />
                    </div>
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                    <Form.Item
                      label="Expected delivery date"
                      name={'delivery_date'}
                      rules={[
                        {
                          type: 'object',
                          required: true,
                          message: 'Please select date!',
                        },
                      ]}
                    >
                      <DatePicker
                        disabledDate={current => {
                          let customDate = moment().format('YYYY-MM-DD');
                          return current && current < moment(customDate, 'YYYY-MM-DD');
                        }}
                        disabled={type !== 'expert' ? true : false}
                        style={{ width: '100%' }}
                        size="large"
                      />
                    </Form.Item>
                  </Col>
                </Row>

                {/* <div style={{ marginBottom: '10px' }}>
            Please review the Quotation Details carefully. By pressing Accept Quotation, you are
            entering into a Service Contract. The terms are governed by the Client Agreement (for
            clients) or the Service Provider Agreement (for service providers). Each party is
            responsible for reviewing their respective agreement.
          </div> */}

                {type === 'customer' && (
                  <div className="flex-x center">
                    <Button key="nocalcel" className="mr15" danger onClick={() => onCancel()}>
                      Decline and cancel request
                    </Button>
                    <Button key="accept" type="primary" onClick={() => onFinish()}>
                      Accept quotation
                    </Button>
                  </div>
                )}
                {type === 'expert' && (
                  <div className="flex-x center">
                    <Button key="nocalcel" className="mr15" danger onClick={() => close(false)}>
                      Cancel
                    </Button>
                    <Tooltip
                      title="Please review the Quotation Details carefully. By pressing Accept Quotation, you are
            entering into a Service Contract. The terms are governed by the Client Agreement (for
            clients) or the Service Provider Agreement (for service providers). Each party is
            responsible for reviewing their respective agreement."
                    >
                      <Button
                        key="accept"
                        type="primary"
                        loading={isCommonUpdateLoading}
                        disabled={isCommonUpdateLoading}
                        onClick={() => onFinish()}
                      >
                        Accept & send quotation
                      </Button>
                    </Tooltip>
                  </div>
                )}
              </Form>
            </TabPane>
            {/* {type == 'expert' && ( */}
            <TabPane tab="History" key="2">
              <Table
                dataSource={questionData.quotation_detail_two.reduce(
                  (acc, cur, index) => {
                    acc.push({
                      ...cur,
                      fee_due: cur.percentage_of_fee_due + '%',
                      billing_plan_id: cur.billing_plan_id == 1 ? 'Monthly' : 'One Time',
                      rejected : cur.rejected == 1 ? 'Yes' : 'No',
                    });
                    if (index == questionData.quotation_detail_two.length - 1) {
                      acc.push({
                        // ...cur,
                        // fee_due: 5,
                        Current_payable_amount:
                          'Total:$' +
                          questionData.quotation_detail_two.reduce(
                            (acc, cur) => acc + cur.rejected == 1 ? 0 :cur.Current_payable_amount,
                            0,
                          ) +
                          '/-',
                      });
                    }
                    return acc;
                  },

                  [],
                )}
                columns={[
                  {
                    title: 'ID',
                    dataIndex: 'id',
                    key: 'id',
                  },
                  {
                    title: 'Assignment Title',
                    dataIndex: 'assignment_title',
                    key: 'assignment_title',
                  },
                  {
                    title: 'Price ($)',
                    dataIndex: 'price',
                    key: 'price',
                  },
                  {
                    title: 'Billing Plan',
                    dataIndex: 'billing_plan_id',
                    key: 'billing_plan_id',
                  },
                  // {
                  //   title: 'Delivery Date',
                  //   dataIndex: 'delivery_date',
                  //   key: 'delivery_date',
                  // },
                  {
                    title: 'Fee Due (%)',
                    dataIndex: 'fee_due',
                    key: 'fee_due',
                  },
                  {
                    title: ' Quotation Rejected',
                    dataIndex: 'rejected',
                    key: 'rejected',
                  },
                  {
                    title: 'Amount ($)',
                    dataIndex: 'Current_payable_amount',
                    key: 'Current_payable_amount',
                  },
                  
                ]}
                rowKey="id"
                pagination={false}

                // pagination={{ pageSize: 5 }}
              />
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  marginTop: '10px',
                  marginRight: '50px',
                }}
              >
                {/* <span>
                  Total Paid Amount ($) :{' '}
                  {questionData.quotation_detail_two.reduce(
                    (acc, cur) => acc + cur.Current_payable_amount,
                    0,
                  )}
                </span> */}
              </div>
            </TabPane>
            {/* )} */}
          </Tabs>
        </>
      )}
    </Modal>
  );
};

export default QuotationModal;
